import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiActivity, FiThermometer, FiAlertTriangle } from 'react-icons/fi';

const Header = () => {
  return (
    <header className="bg-white shadow-lg border-b-4 border-blue-500">
      <div className="container mx-auto px-4 py-4">
        <Link to="/" className="flex items-center space-x-3 hover:opacity-80 transition-opacity">
          <div className="flex items-center space-x-2">
            <SafeIcon icon={FiActivity} className="text-3xl text-blue-600" />
            <SafeIcon icon={FiThermometer} className="text-2xl text-orange-500" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-800">PH Ocean Monitor</h1>
            <p className="text-sm text-gray-600">Coral Temperature Warning System</p>
          </div>
        </Link>
      </div>
    </header>
  );
};

export default Header;